module.exports = __webpack_public_path__ + "static/media/Step5.de56f04f.png";